import styled from 'styled-components'

export default styled.div`
  flex: 1 1 275px;
  display: -ms-flexbox;
  -ms-flexbox: 1 1 275px;
  -ms-flex-direction: column;
  max-width: 275px;
  padding-right: 5px;
  @media screen and (max-width: 800px) and (-ms-high-contrast: active), screen and (max-width: 800px) and (-ms-high-contrast: none) {
    width: 100% !important;
    display: block !important;
  }
`
